import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BestJobComponent } from './best-job.component';

@NgModule({
  declarations: [BestJobComponent],
  imports: [CommonModule],
  exports: [BestJobComponent],
})
export class BestJobModule {}
